import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Tab } from "semantic-ui-react";
import { resourceUpdated, selectAllResources, selectResourceById } from "../../slices/resourceCollection/resourceCollectionSlice";
import { selectChangedResourcesList } from "../../slices/changedResourcesList/changedResourcesListSlice";
import { changeTabFocus, selectTabFocus, selectTabMenu } from "../../slices/tabPane/tabPaneSlice";
import { editModeOff, selectEditMode } from "../../slices/editMode/editModeSlice";
import { selectCurrentUserApiToken, selectSseConnectionId } from "../../slices/currentUser/currentUserSlice";
import deleteEmptyElementsInObjectRecursive from "../../functions/deleteEmptyJsonElements";
import submitUpdatedResource from "../resourceDisplayCommonFunctions/submitUpdatedResource";
import { selectConceptCode } from "../../slices/codeSystemTermDetail/codeSystemTermDetailSlice";

const changeResourceViewTab = async (foi, parentResourceDetail, apiToken, connectionId, tabIndex, resourceCollection,
    changedResourcesList, dispatch, navigate, tabMenu, tabFocus, resourceJson, editMode,
    jsonViewEditingState, setJsonViewEditingState, statusChanged, conceptCode, addToast) => {
    let targetTabLabel = tabMenu[tabIndex];
    //console.log(targetTabLabel)
    let resourceType = resourceJson.resourceType;
    if (tabFocus === "JSON View" && editMode && (jsonViewEditingState.fhirEntryStringRevised || statusChanged)) {
        if (window.confirm("You can't leave this tab until you save or discard changes that you've made to the JSON. Click 'OK' to save your changes and then navigate away. Click 'Cancel' and then refresh the browser to discard the changes.")) {
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            deleteEmptyElementsInObjectRecursive(newResourceDetail.revisedResourceJson);
            submitUpdatedResource(foi, newResourceDetail, apiToken, connectionId, dispatch, resourceCollection,
                changedResourcesList, tabFocus, jsonViewEditingState, setJsonViewEditingState, null, addToast);
            dispatch(resourceUpdated(newResourceDetail));
            dispatch(changeTabFocus(tabMenu[tabIndex]));
        }
    } else if (resourceType === "CodeSystem") {
        let allowTabChange = true;
        if (editMode) {
            let confirmMessage = "You can't leave this tab until you save or discard changes that you've made to the term. Click 'OK' to save your changes and then navigate away. Click 'Cancel' and then refresh the browser to discard the changes.";
            if (tabIndex === 1) {
                confirmMessage = "You can't go to the Term Detail tab until you save or discard changes that you've made to the Resource. Click 'OK' to save your changes and then navigate away. Click 'Cancel' and then refresh the browser to discard the changes.";
            }
            if (window.confirm(confirmMessage)) {
                let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
                deleteEmptyElementsInObjectRecursive(newResourceDetail.revisedResourceJson);
                submitUpdatedResource(foi, newResourceDetail, apiToken, connectionId, dispatch, resourceCollection,
                    changedResourcesList, tabFocus, jsonViewEditingState, setJsonViewEditingState, null, addToast);
                dispatch(resourceUpdated(newResourceDetail));
                dispatch(changeTabFocus(tabMenu[tabIndex]));
                dispatch(editModeOff());
            } else {
                allowTabChange = false;
            }
        }
        if (allowTabChange) {
            if (targetTabLabel === "Term Detail" && conceptCode
            ) {
                navigate(`/resources/CodeSystem/${resourceJson.id}#${conceptCode}`, { replace: true });
            } else if (targetTabLabel === "Term Detail") {
                navigate(`/resources/${resourceType}/${resourceJson.id}#TOP`, { replace: true });
            } else {
                navigate(`/resources/${resourceType}/${resourceJson.id}`, { replace: true });
            }
            dispatch(changeTabFocus(tabMenu[tabIndex]));
        }
    } else {
        dispatch(changeTabFocus(tabMenu[tabIndex]));
    }
};

let activeTabIndex = (tabMenu, tabFocus) => {
    for (const index in tabMenu) {
        if (tabMenu[index] === tabFocus) {
            return parseInt(index);
        }
    }
    return 0;
};

const ViewTabPane = ({ foi, jsonViewEditingState, setJsonViewEditingState, statusChanged = false }) => {
    const { addToast } = useToasts();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const connectionId = useSelector(selectSseConnectionId);
    const resourceCollection = useSelector(state => selectAllResources(state));
    const changedResourcesList = useSelector(state => selectChangedResourcesList(state));
    const tabMenu = useSelector(state => selectTabMenu(state));
    const tabFocus = useSelector(state => selectTabFocus(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceJson = parentResourceDetail?.revisedResourceJson || parentResourceDetail?.resourceJson;
    const editMode = useSelector(state => selectEditMode(state));
    const conceptCode = useSelector(selectConceptCode);

    return <Tab className="viewTabPane"
        menu={{ secondary: true, pointing: true }}
        panes={tabMenu.map(item => { return { menuItem: item }; })}
        activeIndex={activeTabIndex(tabMenu, tabFocus)}
        onTabChange={(e, data) => {
            changeResourceViewTab(foi, parentResourceDetail, apiToken, connectionId, data.activeIndex, resourceCollection,
                changedResourcesList, dispatch, navigate, tabMenu, tabFocus, resourceJson, editMode,
                jsonViewEditingState, setJsonViewEditingState, statusChanged, conceptCode, addToast
            );
        }}
    />
};

export default ViewTabPane;